import React from 'react'
import { Container } from './styles'
import { Images } from '~/assets/images'

export const Default = ({ show }: { show: boolean }): JSX.Element => {
  if (!show) return <></>

  return (
    <Container>
      <Images.searchIdle />
    </Container>
  )
}
